import { Injectable } from '@angular/core';
import { Photographer } from '../models/new/photographer';
import { ColorShots, Order, OrderDetail, OrderFilters, OrderStatus } from '../models/new/order';
import { Status } from '../models/new/status';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { DateRange } from '../models/new/dateRange';
import { AspectRatio, CodifiedUse, MediaFormat, Shot, ShotType } from '../models/new/shot';
import { Category } from '../models/new/category';
import { Brand } from '../models/new/brand.model';
import { Color, SizeGroup, Style } from '../models/new/style';
import { Warehouse } from 'src/app/shared/types/warehouse.model';
import { ShotResume } from '../models/new/shotResume';

@Injectable({
	providedIn: 'root'
})
export class ResumeMapper {
	toShotResume(shot: any) {
		return new ShotResume({
			requiredShots: shot.requiredShots,
			approvedShots: shot.approvedShots,
			rejectedShots: shot.rejectedShots,
			uploadedShots: shot.uploadedShots,
			missingShots: shot.missingShots
		});
	}
}
